import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import { GENDERS } from 'dpl/shared/constants/breeder_app';

import HealthTestingMobileMenu from '../overview/HealthTestingMobileMenu';

const MAX_HEALTH_TESTS_TO_SHOW = 2;

function getParentHealthTestingDescription(healthTests) {
  const remainingTestCount = healthTests.length - MAX_HEALTH_TESTS_TO_SHOW;
  const healthTestsToDisplay = healthTests
    .slice(0, MAX_HEALTH_TESTS_TO_SHOW)
    .join(', ');
  return `${healthTestsToDisplay}${
    remainingTestCount > 0 ? `, +${remainingTestCount} more` : ''
  }.`;
}

export default function ParentHealthTestingDescription({ dog }) {
  const healthTesting = dog.health_testing;

  const hasHealthTests = healthTesting.documented_health_tests?.length > 0;

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const innerTooltipRef = useRef(null);

  return (
    <div className="ParentHealthTestingDescription w-100 font-14 bg-teal-light br3 ph4 pv3 inline-flex items-center mt4">
      <Icon
        name="fetch-pets-heart"
        className="ParentHealthTestingDescription__icon bg-white br-100 mr4 green-dark-700"
        width="32px"
        height="32px"
      />
      <div ref={innerTooltipRef}>
        <p className="fw-medium green-dark-900">{healthTesting.title}</p>
        <HealthTestingMobileMenu
          isVisible={isTooltipOpen}
          onCloseClick={() => setIsTooltipOpen(false)}
          portalMountRef={innerTooltipRef}
          healthTesting={healthTesting}
          dog={dog}
        />
        {hasHealthTests && dog.health_test_results_public && (
          <p className="green-dark-900">
            {getParentHealthTestingDescription(
              healthTesting.documented_health_tests
            )}{' '}
            <button
              type="button"
              className="underline stone-700"
              onClick={() => setIsTooltipOpen(true)}
            >
              See details
            </button>
          </p>
        )}
      </div>
    </div>
  );
}

ParentHealthTestingDescription.propTypes = {
  dog: PropTypes.shape({
    breed_name: PropTypes.string,
    breed_slug: PropTypes.string,
    description: PropTypes.string,
    gender: PropTypes.oneOf(Object.values(GENDERS)),
    health_testing: PropTypes.shape({
      title: PropTypes.string,
      documented_health_tests: PropTypes.arrayOf(PropTypes.string)
    }),
    health_tier_title: PropTypes.string,
    health_test_results_public: PropTypes.bool,
    health_test_results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        description: PropTypes.string,
        health_test_id: PropTypes.number,
        health_test_name: PropTypes.string,
        health_test_result_documents: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            is_file: PropTypes.bool,
            name: PropTypes.string,
            url: PropTypes.string
          })
        )
      })
    ),
    name: PropTypes.string,
    profile_photo_url: PropTypes.string
  }).isRequired
};
